<template>
  <div v-show="product.length != 0" class="home">
    <div class="clearfix" style="margin-top: 20px">
      <div
        class="create create-products"
        style="height: auto;margin-bottom: 0px;"
      >
        <div class="title" style="height: auto;">
          <img src="../../assets/img/ico-library-black.svg">
          <span>Other Products</span>
        </div>
        <div class="product">
          <ul
            v-infinite-scroll="load"
            class="infinite-list"
            infinite-scroll-distance="150"
          >
            <li v-for="(item, index) in product" :key="index">
              <r-link :to="`/product/${item.type}/${item.id}`">
                <div class="product-list">
                  <div class="posi">
                    <div v-if="item.isNew" class="tag">new</div>
                    <div
                      v-if="item.isHot"
                      class="tag tagHot"
                      :class="{ tagtop16: item.isHot == false }"
                    >
                      hot
                    </div>
                    <div v-if="item.favorableDiscount > 0" class="tag tagzk">
                      -{{ item.favorableDiscount | percentFilter }}
                    </div>
                  </div>
                  <div
                    class="product-img"
                    @mouseenter="
                      changeImageSrc(
                        item.suspendImageUrl,
                        item.mainShowImageUrl,
                        index
                      )
                    "
                    @mouseleave="
                      changeImageSrc(
                        item.suspendImageUrl,
                        item.mainShowImageUrl,
                        index
                      )
                    "
                  >
                    <images
                      :url="item.mainShowImageUrl"
                      width="600"
                      height="600"
                    />
                  </div>
                  <div class="info">
                    <p class="ellipsis2">{{ item.model }}</p>
                    <p v-html="item.blankContent" />
                    <p class="price">
                      Price
                      <span v-if="item.favorablePrice">
                        <span>${{ item.favorablePrice | MoneyFormat }}</span>
                        <s>${{ item.price | MoneyFormat }}</s>
                      </span>
                      <span v-else>
                        <span>${{ item.price | MoneyFormat }}</span>
                      </span>
                    </p>
                  </div>
                </div>
              </r-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <a-carousel autoplay>
      <div v-for="item in adveList" :key="item.id">
        <img :src="item.imageUrl" @click="toAdvDetail(item)">
      </div>
    </a-carousel>
  </div>
</template>
<script>
import images from '@/components/images'
import { blankProductPage } from '../../api/product'
import { advertiseList } from '@/api/adve'
export default { // 所要传的id
  components: {
    images
  },
  props: ['recommendFromProductId'],
  data() {
    return {
      adveList: [],
      imgWidth: 600,
      imgHeight: 600,
      product: [],
      pageTotal: 1,
      page: {
        current: 0,
        size: 12,
        keyword: '', // 关键字
        isIndexRecommend: true
      }
    }
  },
  async mounted() {
    const { data } = await advertiseList({ advertiseType: 2 })
    this.adveList = data.itemList
    console.log(data)
  },
  methods: {
    load() {
      this.page.current += 1
      this.getblankProductRecommend()
    },
    changeImageSrc(susImg, mainImg, index) {
      if (susImg) {
        this.product[index].mainShowImageUrl = susImg
        this.product[index].suspendImageUrl = mainImg
        this.$forceUpdate()
      }
    },
    // 产品列表
    async getblankProductRecommend() {
      const { data } = await blankProductPage({
        current: this.page.current,
        size: this.page.size,
        keyword: this.page.keyword,
        recommendFromProductId: this.recommendFromProductId
      })
      this.pageTotal = data.total
      for (let i = 0; i < data.records.length; i++) {
        this.product.push(data.records[i])
      }
      console.log(this.product)
    },
    toAdvDetail(item) {
      if (item.jumpUrl) {
        window.open(item.jumpUrl, '_blank')
      }
    }
  }
}
</script>
<style scoped>
.posi {
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  z-index: 1;
}
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 346px;
  line-height: 346px;
  overflow: hidden;
}

.ant-carousel >>> .slick-slide img {
  width: 100%;
  height: 346px;
  margin: 20px 0px;
}
</style>
